<template>

  <div v-loading="loading" element-loading-text="拼命加载中">

    <el-form class="search-box" ref="form" :model="form" :rules="rules">
      <el-form-item prop="order_number">
        <el-input
            ref="search"
            @focus="stopKeyborad"
            @blur="stopKeyborad"
            v-model="form.order_number"
            @keydown.enter.native.prevent="getAnnex"
            placeholder="扫描产品订单编号"
        >
          <el-button
              @click.prevent="getAnnex"
              slot="append"
              icon="el-icon-search"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <!--    展示是否为多品-->
    <div class="grid-content bg-purple"
         style="color: #bd2c00"
          v-if="card_data.length>0"
    >
      <h2 v-if="order_type == 1">订单类型:单品</h2>
      <h2 v-else >订单类型:多品</h2>
    </div>
    <!-- 卡片捡取列表 -->
    <template v-for="item of card_data">

        <div class="show"  :label="item.id" :key="item.id" @click="checkShelf(item)">
          <div class="line">
            <el-row :gutter="10">
              <el-col :span="16">
                <el-row>
                  <el-col :span="24">
                    <div class="grid-content bg-purple"
                         >
                      <h3>卡片名称</h3>
                      <p>{{ item.annex.name }}</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <h3>数量</h3>
                      <p style="color:  #bd2c00">{{ item.xls_quantity }}</p>
                    </div>
                  </el-col>
                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <h3>SKU</h3>
                      <p>{{ item.sku }}</p>
                    </div>
                  </el-col>

                  <el-col :span="24" v-if="item.shelf_id!==null">
                    <div class="grid-content bg-purple-light" style="color: #3967FF">
                      <p v-if="user_info.depot == 0">货架号: {{ item.annex.annex_shelf_no }}</p>
                      <p v-else-if="user_info.depot == 1">货架号: {{ item.annex.xm_annex_shelf_no }}</p>
                    </div>
                  </el-col>

                  <el-col :span="24">
                    <div class="grid-content bg-purple-light">
                      <p v-if="item.status===0">状态: <span style="color: #9a6e3a">未配货</span></p>
                      <p v-else-if="item.status===8">状态: <span style="color: #55a532">已配货</span></p>
                      <p v-else>状态: 其它</p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col v-if="item.annex.image!=''" :span="8"  @click.stop>
                <img :src="item.annex.image" alt="" width="100%" preview="1" preview-text='图片展示'  @click.stop>
              </el-col>
            </el-row>

          </div>
        </div>

    </template>
    <el-dialog
        title="提示"
        :visible.sync="centerDialogVisible"
        width="90%"
        top="30vh"
        :close-on-click-modal="false"
        center>
      <el-form class="search-box" ref="shelfForm" :model="shelfForm" :rules="rules">
        <el-form-item prop="shelf_number">
          <el-input
              ref="shelfSearch"
              @focus="stopKeyborad"
              @blur="stopKeyborad"
              v-model="shelfForm.shelf_number"
              @keydown.enter.native.prevent="pickAnnex()"
              :placeholder="placeholderInfo"
          >
            <el-button
                @click.prevent="pickAnnex()"
                slot="append"
                icon="el-icon-search"
            ></el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--</span>-->
    </el-dialog>
  </div>

</template>

<script>

export default {
  name: "PickList",
  data() {
    return {
      centerDialogVisible:false,
      loading: false,
      form:{
        order_number:''
      },
      shelfForm:{
        shelf_number:'',
      },
      rules:{
        order_number: [
          {
            required: true,
            message: "请扫描订单编号",
            trigger: "blur"
          }
        ],
      },
      order_number:'',
      card_data:[],
      order_type:0,
      focus_item:[],//选中的卡片
      placeholderInfo:'请扫描卡片的货架号！',
      user_info:JSON.parse(localStorage.getItem('user_info'))
    }
  },
  methods: {

    getAnnex(  ){
      let _this = this;
      if(!_this.user_info && !_this.user_info.depot){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '请重新登陆并清除缓存'),
          ])
        });
      }
      if( _this.form.order_number !== ''){
        _this.order_number =  _this.form.order_number;
      }
      let param = {
        order_number:_this.order_number,
      };
      _this.card_data = [];
      this.http.fetchGet(_this.api.getAnnexList, param).then((res) => {
        if(res.data.code != 200 || res.data.data.annex.length <= 0 ){
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '暂无卡片数据'),
            ])
          });
          return false
        }else{
          _this.form.order_number = '';
          //设置订单类型
          _this.order_type = res.data.data.product.length;
          //设置卡片数据
          _this.card_data = res.data.data.annex;
        }
      })

    },
    checkShelf(item){
      if(item.status === 8 ){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '已配货，无需多次配货'),
          ])
        });
        return false
      }
      this.centerDialogVisible = true,
      this.focus_item = item;
      //加定时器
      this.$nextTick(() => {
        this.shelfOnfocusEvent()
      })
    },
    pickAnnex( ){
      let _this = this;
      let param = {
        check_detail_id:_this.focus_item.id,
        annex_id:_this.focus_item.annex.id,
        shelf_no:_this.shelfForm.shelf_number,
        warehouse:_this.user_info.depot
      };
      //获取货架号
      let shelf_no  = _this.focus_item.annex.annex_shelf_no;
      if(_this.user_info.depot == 1)  shelf_no = _this.focus_item.annex.xm_annex_shelf_no;

      if( shelf_no != _this.shelfForm.shelf_number){
        const h = this.$createElement;
        this.$message({
          offset: 50,
          duration: 3000,
          message: h('p', null, [
            h('span', null, '货架号不匹配'),
          ])
        });
        return false
      }
      this.http.fetchPost(_this.api.pickAnnex, param).then((res) => {
        console.log(res.data.data)
        var data = res.data;
        if (data.code === 200) {
          const h = this.$createElement;
          this.$message({
            offset: 50,
            duration: 3000,
            message: h('p', null, [
              h('span', null, '配货成功 '),
              // h('i', { style: 'color: teal' }, 'VNode')
            ])
          });

          this.centerDialogVisible = false
          this.card_data = []
          this.focus_item = []
          this.alter = false
          this.shelfForm.shelf_number = ''
          this.$nextTick(() => {
            this.refreshShelf()
          })
        } else {
          this.$message.error(this.shelfForm.shelf_number + " " + data.message)
        }

      })
    },
    stopKeyborad(e){
      //尝试一下
      e.target.setAttribute('readonly', true);
      setTimeout(() => {
        e.target.removeAttribute('readonly');
      }, 100);
    },
    //扫描货架自动获取光标
    shelfOnfocusEvent() {
      this.$refs.shelfSearch.focus()
    },
    //上架之后更新数据
    refreshShelf() {
      this.onfocusEvent()
      this.getAnnex()
    },
    //自动获取光标
    onfocusEvent() {
      this.$refs.search.focus()
    },
  },
  //被 keep-alive 缓存的组件激活时调用
  activated() {
    this.onfocusEvent()
  },
}
</script>
<style scoped lang="stylus">

.el-checkbox
  margin-top 10px
  margin-right 0

.el-checkbox >>> .el-checkbox__input
  vertical-align: top

.is-checked .show
  background-color #a4c9f1
  color #606266

.show {
  //float: left;
  width: 96%;

  .line {
    box-sizing: border-box;
    border: 1px solid black;
    //margin-top: 1rem;
    margin: 1px;
    //float: left;
    width: 99%;

    .el-col {
      margin-top 3px
      margin-bottom: 3px;
      padding 0 5px

      &:last-child {
        //margin-bottom: 0;
      }
    }

    .grid-content {
      //text-align center

      h3 {
        font-size 14px
      }
    }

  }
}


.old-count
  margin-left: 5px;
  width: 20px;
  height: 20px;
  background-color: #ea4444;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 10px


</style>